import React, { useEffect,useState } from 'react'
import _ from 'lodash';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectBusinessesQueryItems } from '../../../../../redux/businesses/selector';
import { business } from '../../../../../redux/businesses/action';
import BusinessComponent from '../components/business.component';
import PageLoader from '../../../../../components/PageLoader';
import { toast } from 'react-toastify';

const Business= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectBusinessesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedBusiness,
    setSelectedBusiness
  ] = useState<any>([])
 
  const fetchBusinessById= ()=>{
    dispatch(business.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business/query`,entity:'business',jsonData:{
          
    Records: [
      {
        "Context": {},
                "Message": {
                    "Id": parmas?.id,
                                }                }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBusiness({ ...selectedBusiness, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchBusinessById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedBusiness(queryItems?.result?.items)
      }
    },
    [isQuery]
  )


const back=()=>{
  navigate('/management/platform-management/businesses')
} 

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id == 0  && selectedBusiness.Password === selectedBusiness.ConfirmPassword) {
      await dispatch(business.resetAction({ actionType: 'create' }))
    await dispatch(business.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business`,entity:'business',jsonData:{
          
    Records: [
      {
        
       "Context": {},
       "Message": {
         ...selectedBusiness,
         DBaaSProgramPolicyId: 0
       }
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})
    }
    else{
      toast.info(
        'Password and Confirm Password must be same',
         );
    }
  }
    return (
    <>
      {isLoading ? <PageLoader /> : 
          <BusinessComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedBusiness={selectedBusiness}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={parmas?.id}
          
          />  
    }
          </>
    )
    
    }
   
    export default Business;
